export interface IApiConfig{
  apiHost:string;
  urlPrefix:string;
  timeout:number;
  appId:string;
}
